var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOnStyledHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 83,
    viewBox: "0 0 320 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89605_109216)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H320V83H0V0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_89605_109216)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_89605_109216)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 83,
    transform: "matrix(-1 0 0 1 319.781 -0.0390625)",
    fill: "url(#paint0_linear_89605_109216)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_89605_109216)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 111.824,
    cy: 83.6719,
    r: 95.9102,
    fill: "#305FE3"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1987 79.879C13.1044 77.3096 10.5712 75.148 7.72164 73.4987C4.94061 71.7319 1.86884 70.4931 -1.34508 69.8421L-4.38766 67.9961L-6.09199 70.9163C-7.47225 73.2812 -3.52553 78.2717 2.7233 82.0628C8.97206 85.8539 15.1567 87.0101 16.537 84.6452L18.2413 81.725L15.1987 79.879Z",
    fill: "#FFCC31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1987 79.879C13.1044 77.3096 10.5712 75.148 7.72164 73.4987C4.94061 71.7319 1.86884 70.4931 -1.34508 69.8421L-4.38766 67.9961L-6.09199 70.9163C-7.47225 73.2812 -3.52553 78.2717 2.7233 82.0628C8.97206 85.8539 15.1567 87.0101 16.537 84.6452L18.2413 81.725L15.1987 79.879Z",
    fill: "#FFCC31"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.94265 73.0343L1.19068 72.5781L-2.20312 78.393C-1.98585 78.5907 -1.76172 78.7882 -1.53075 78.9854L1.94265 73.0343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.48864 75.1984L4.73676 74.7422L1.08594 80.9975C1.32575 81.1617 1.57099 81.3241 1.81937 81.4852L5.48864 75.1984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2109 85.6137C11.5293 85.6786 11.8379 85.7313 12.1367 85.7719L14.952 80.9484L14.2002 80.4922L11.2109 85.6137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.450014 72.1437L-0.301864 71.6875L-3.49219 77.1537C-3.28861 77.3693 -3.07546 77.5856 -2.85275 77.8025L0.450014 72.1437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.0174 79.1554L11.2656 78.6992L7.82812 84.5889C8.1115 84.6983 8.39084 84.7998 8.66719 84.8957L12.0174 79.1554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.4882 80.046L12.7362 79.5898L9.48438 85.1616C9.78202 85.2526 10.0731 85.3332 10.3593 85.4069L13.4882 80.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.9836 76.0968L6.23172 75.6406L2.55469 81.9408C2.61999 81.9811 2.68404 82.0219 2.74985 82.0618C2.93615 82.1749 3.12238 82.2855 3.30854 82.3936L6.9836 76.0968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.42938 76.9913L7.67743 76.5352L4.01562 82.8093C4.27525 82.9523 4.53408 83.0903 4.7921 83.2233L8.42938 76.9913Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2479 81.7178C16.8676 84.0827 10.683 82.9265 4.43424 79.1354C-1.81462 75.3443 -5.76131 70.3539 -4.38105 67.9889C-3.00079 65.624 3.18377 66.7802 9.4326 70.5713C15.6814 74.3624 19.6282 79.3529 18.2479 81.7178Z",
    fill: "#FFCC31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6508 79.5391C13.7095 81.1519 9.49195 80.3635 5.23053 77.7781C0.969107 75.1927 -1.7224 71.7895 -0.781053 70.1767C0.16021 68.564 4.37777 69.3524 8.63919 71.9378C12.9006 74.5231 15.592 77.9264 14.6508 79.5391Z",
    fill: "#FFCC31"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.0333 71.605C10.5205 71.2548 9.98868 70.9121 9.43799 70.5769C7.7081 69.5182 5.8849 68.6267 3.99219 67.9141L12.1777 82.5218C14.2927 83.0521 16.0659 83.0986 17.1987 82.6076L11.0333 71.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.4608 82.0154L2.24116 67.3467C1.32987 67.081 0.396632 66.9008 -0.546875 66.8086L7.21866 80.667C8.27159 81.183 9.3543 81.6333 10.4608 82.0154Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6508 79.5391C13.7095 81.1519 9.49195 80.3635 5.23053 77.7781C0.969107 75.1927 -1.7224 71.7895 -0.781053 70.1767C0.16021 68.564 4.37777 69.3524 8.63919 71.9378C12.9006 74.5231 15.592 77.9264 14.6508 79.5391Z",
    fill: "#FFCC31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97553 73.0687C11.7255 75.3439 14.2585 78.2518 14.1713 80.0161C14.366 79.8995 14.5295 79.7356 14.6473 79.5391C15.5886 77.9264 12.8971 74.5231 8.63568 71.9377C4.37426 69.3524 0.156695 68.564 -0.784569 70.1767C-0.897834 70.3759 -0.961099 70.6006 -0.96875 70.8307C0.510555 69.911 4.22551 70.7936 7.97553 73.0687Z",
    fill: "#FFCC31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.3125 76.5208L7.21968 73.4309L7.21924 73.4307L6.49365 72.9904L6.49311 72.9902L4.56485 71.8203L3.83413 71.8398L6.29392 73.3321C7.33884 73.9662 8.07651 74.7601 8.17117 75.2938L4.01069 72.7698L3.28005 72.7893L8.07022 75.6955C7.70325 76.0717 6.49692 75.8105 5.27851 75.0714L3.32448 73.8859L3.125 74.2277L3.1392 74.2363L5.949 78.1909C6.55029 78.5279 7.14668 78.8278 7.72975 79.0897L5.14675 75.4542L5.80507 75.8536C7.531 76.9007 9.24009 77.2596 9.71928 76.6959L11.0277 77.4898L11.7584 77.4702L9.849 76.3118C9.78918 75.8726 9.59229 75.4646 9.28745 75.1483L11.5818 76.5403L12.3125 76.5208Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.485 14.4745C319.916 20.7174 313.799 24.4532 307.836 22.8106C301.846 21.1843 298.277 14.7808 299.852 8.51568C301.421 2.27275 307.538 -1.46299 313.501 0.179614C319.486 1.82804 323.054 8.23155 321.485 14.4745Z",
    fill: "#FFCC00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M320.757 6.48625C319.408 3.48722 316.821 1.09411 313.501 0.179614C307.538 -1.46299 301.421 2.27275 299.852 8.51568C299.524 9.82183 299.418 11.142 299.525 12.4259C306.567 10.3179 313.644 8.33798 320.757 6.48625Z",
    fill: "#FCDC59"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M309.078 23.0759C311.63 23.4475 314.167 22.8916 316.277 21.6028C314.374 21.9781 312.486 22.3813 310.577 22.7787C310.078 22.8778 309.578 22.9769 309.078 23.0759Z",
    fill: "#FCDC59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M318.757 13.5341C317.56 18.2937 312.913 21.1322 308.366 19.8799C303.819 18.6276 301.108 13.762 302.304 9.00234C303.501 4.24265 308.148 1.40415 312.695 2.65648C317.236 3.93096 319.947 8.79651 318.757 13.5341Z",
    fill: "#DA8100"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M318.896 13.9524C317.716 18.6457 313.127 21.4294 308.665 20.2004C304.182 18.9655 301.523 14.1617 302.697 9.49061C303.877 4.79733 308.465 2.01359 312.927 3.24263C317.389 4.47167 320.07 9.28129 318.896 13.9524Z",
    fill: "#F0AA00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M315.533 7.94273L312.842 7.17641C313.214 7.72853 313.409 8.44151 313.292 9.30053L315.08 9.80937L314.855 10.7317L313.09 10.229C312.463 12.0466 310.856 12.8805 308.752 12.3517C309.659 14.2067 310.583 16.4657 311.502 18.7467L309.93 18.2991C309.081 16.2025 308.282 14.2842 307.18 11.9981L307.457 10.8562L308.362 11.1136C310.128 11.6164 311.278 11.0516 311.69 9.83051L307.986 8.77605L308.211 7.85371L311.871 8.89591C311.896 7.75241 311.163 6.98013 309.742 6.57551L308.579 6.24446L308.867 5.05859L315.736 7.01426L315.512 7.9366L315.533 7.94273Z",
    fill: "#EA9C00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M315.346 7.65758L312.654 6.89125C313.027 7.44337 313.222 8.15636 313.105 9.01538L314.892 9.52422L314.668 10.4466L312.902 9.94385C312.276 11.7614 310.669 12.5953 308.564 12.0665C309.477 13.8996 310.417 16.1867 311.314 18.4615L309.743 18.014C308.894 15.9174 308.094 13.999 306.992 11.713L307.27 10.571L308.174 10.8285C309.94 11.3312 311.09 10.7665 311.502 9.54536L307.799 8.49089L308.023 7.56855L311.684 8.61076C311.708 7.46725 310.975 6.69498 309.554 6.29036L308.391 5.9593L308.68 4.77344L315.549 6.72911L315.324 7.65145L315.346 7.65758Z",
    fill: "#FFCC00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_89605_109216",
    x: -0.21875,
    y: -0.0390625,
    width: 320,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2.5 2.5",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2476
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(70, 53, 53, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_89605_109216"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_89605_109216",
    x: -77.3859,
    y: -105.538,
    width: 378.42,
    height: 378.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 46.45,
    result: "effect1_foregroundBlur_89605_109216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89605_109216",
    x1: 4.47727,
    y1: 101.76,
    x2: 312.162,
    y2: 17.0566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C51FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461538,
    stopColor: "#6E92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89605_109216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H320V83H0V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_89605_109216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 83,
    fill: "white",
    transform: "matrix(-1 0 0 1 319.781 -0.0390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOnStyledHeader);
export default __webpack_public_path__ + "static/media/AddOnStyledHeader.4a301d22e441683400dd1db13da5e832.svg";
export { ForwardRef as ReactComponent };